
const BASE_URL = 'https://carwashapi.iosx.in:3098/api/v1/';
export const API_URL = 'https://carwashapi.iosx.in:3098/';
export default BASE_URL;